export default "__VITE_ASSET__CbHWeMza__"